<template>
    <div>
        There are no search results because you selected filters that have no
        matches...
    </div>
</template>

<script>
export default {
  name: "NoSearchResult"
};
</script>

<style scoped>
</style>
